import { render, staticRenderFns } from "./acquistiNetwork.vue?vue&type=template&id=1f3d1e56&"
import script from "./acquistiNetwork.vue.ts?vue&type=script&lang=ts&"
export * from "./acquistiNetwork.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports